import React from "react";
import { safeJSONParse } from "../../../utils/helper";
import styles from "../agent-response.module.scss";

type DataTalkQueryPlannerAgentProps = {
    parsedContent: any;
};

export default function DataTalkQueryPlannerAgent({
    parsedContent,
}: DataTalkQueryPlannerAgentProps): JSX.Element {
    const answer = safeJSONParse(parsedContent?.finalAnswer);
    const question = parsedContent?.question;
    const responseData = answer;

    return (
        <div className={styles.pressReleaseContent}>
            {/* Response Type */}
            {responseData?.response_type && (
                <div style={{ marginBottom: "12px" }}>
                    <h3 style={{ marginBottom: "7px" }}>
                        Query Planning Response
                    </h3>
                    <p style={{ marginBottom: "0" }}>
                        <strong>Response Type:</strong>{" "}
                        <span style={{
                            textTransform: "capitalize",
                            color: responseData.response_type === "clarification" ? "#ff9800" : "#4caf50"
                        }}>
                            {responseData.response_type}
                        </span>
                    </p>
                </div>
            )}

            {/* Query Plan */}
            {responseData?.plan && (
                <div style={{ marginBottom: "12px" }}>
                    <h4 style={{ marginBottom: "0" }}>Query Plan:</h4>
                    <div style={{
                        marginTop: "8px",
                        padding: "12px",
                        backgroundColor: "#e8f5e9",
                        borderLeft: "4px solid #4caf50",
                        borderRadius: "4px"
                    }}>
                        <pre style={{
                            margin: "0",
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-word",
                            fontFamily: "inherit",
                            fontSize: "13px"
                        }}>
                            {typeof responseData.plan === 'string'
                                ? responseData.plan
                                : JSON.stringify(responseData.plan, null, 2)}
                        </pre>
                    </div>
                </div>
            )}

            {/* Clarification Section */}
            {responseData?.clarification && (
                <div style={{ marginBottom: "12px" }}>
                    <h4 style={{ marginBottom: "0" }}>Clarification Needed:</h4>

                    {/* Clarification Question */}
                    {responseData.clarification.question && (
                        <div style={{
                            marginTop: "8px",
                            padding: "12px",
                            backgroundColor: "#fff3e0",
                            borderLeft: "4px solid #ff9800",
                            borderRadius: "4px"
                        }}>
                            <p style={{ marginBottom: "0", fontWeight: "500" }}>
                                {responseData.clarification.question}
                            </p>
                        </div>
                    )}

                    {/* Context */}
                    {responseData.clarification.context && (
                        <div style={{ marginTop: "12px" }}>
                            <h5 style={{ marginBottom: "4px", fontSize: "14px", color: "#666" }}>
                                Context:
                            </h5>
                            <div style={{
                                padding: "10px",
                                backgroundColor: "#f5f5f5",
                                borderRadius: "4px",
                                fontSize: "13px"
                            }}>
                                <p style={{
                                    margin: "0",
                                    whiteSpace: "pre-wrap",
                                    wordBreak: "break-word"
                                }}>
                                    {responseData.clarification.context}
                                </p>
                            </div>
                        </div>
                    )}

                    {/* Options */}
                    {responseData.clarification.options && responseData.clarification.options.length > 0 && (
                        <div style={{ marginTop: "12px" }}>
                            <h5 style={{ marginBottom: "8px" }}>Please choose an option:</h5>
                            <ul style={{
                                marginBottom: "0",
                                listStyle: "none",
                                paddingLeft: "0"
                            }}>
                                {responseData.clarification.options.map((option: string, idx: number) => (
                                    <li key={idx} style={{
                                        padding: "8px 12px",
                                        marginBottom: "6px",
                                        backgroundColor: "#fff",
                                        border: "1px solid #ddd",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                        transition: "all 0.2s ease"
                                    }}>
                                        <span style={{ fontWeight: "500", marginRight: "8px" }}>
                                            {idx + 1}.
                                        </span>
                                        {option}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            )}

            {/* Final Question */}
            {question && (
                <div className={styles.finalQuestion}>{question}</div>
            )}
        </div>
    );
}
